import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Popover } from '@openng/optimus-ui/popover';
import { TranslatePipe } from '@ngx-translate/core';
import { StelaNotificationItem } from '../../models/stela-layout.models';
import { RelativeTimePipe } from '../../../pipes/relative-time.pipe';

@Component({
  selector: 'stela-notification-dropdown',
  standalone: true,
  imports: [Popover, TranslatePipe, RelativeTimePipe],
  templateUrl: './stela-notification-dropdown.component.html',
  styleUrl: './stela-notification-dropdown.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StelaNotificationDropdownComponent {
  private static minutesAgo(minutes: number): string {
    return new Date(Date.now() - minutes * 60_000).toISOString();
  }

  readonly notifications = input<StelaNotificationItem[]>([
    { id: '1', icon: 'pi pi-user', message: 'New user registered on the platform', timestamp: StelaNotificationDropdownComponent.minutesAgo(2), variant: 'info' },
    { id: '2', icon: 'pi pi-check-circle', message: 'Task "Review documents" completed', timestamp: StelaNotificationDropdownComponent.minutesAgo(15), variant: 'success' },
    { id: '3', icon: 'pi pi-exclamation-triangle', message: 'Server storage is almost full (92%)', timestamp: StelaNotificationDropdownComponent.minutesAgo(60), variant: 'warning' },
    { id: '4', icon: 'pi pi-calendar', message: 'Meeting with team scheduled for tomorrow', timestamp: StelaNotificationDropdownComponent.minutesAgo(180), variant: 'info' }
  ]);
  readonly badgeCount = input(4);
  readonly notificationClick = output<StelaNotificationItem>();
  readonly viewAll = output<void>();

  onNotificationClick(item: StelaNotificationItem, popover: Popover): void {
    this.notificationClick.emit(item);
    popover.hide();
  }

  onViewAll(popover: Popover): void {
    this.viewAll.emit();
    popover.hide();
  }
}
